export default "__VITE_ASSET__5ff7f877__"